import { RoleLabel } from '@infuse/iam/role/type';

export enum UserLevel {
  ORGANISATION = 'organisation',
  TENANT = 'tenant',
  DOMAIN = 'domain'
}

export interface User {
  id: string;
  name: string;
  email: string;
  roleLabels: RoleLabel[];
  externalId: string;
  modifiedAt: Date;
  createdAt: Date;
  version: number;
  active: boolean;
  locale?: string;
  organisationId?: string;
  organisationName?: string;
  tenantId?: string;
  tenantName?: string;
}

export type CreateUser = Pick<User, 'name' | 'email' | 'locale'> & {
  roles: string[];
};
export type UpdateUser = CreateUser & Pick<User, 'version'>;
